import {
  PaystackCreateIntegrationInterface,
  PaystackPaymentIntegrationInterface,
  PaystackSubAccountInterface,
} from 'modules/profile/payment-gateways/integrations/paystack/types'
import httpClient from 'shared/utils/http-client'

const PAYSTACK_ACCOUNT_API = '/api/payment/integration/paystack/account'

export const paystackConnect = (data: PaystackCreateIntegrationInterface) =>
  httpClient.post<PaystackPaymentIntegrationInterface>(`${PAYSTACK_ACCOUNT_API}/create`, data)

export const getPaystackSubAccounts = (
  data: { secretToken: string },
  config: { signal?: AbortSignal },
) =>
  httpClient.post<PaystackSubAccountInterface[]>(
    `${PAYSTACK_ACCOUNT_API}/subaccount/list`,
    data,
    config,
  )

export const paystackDisconnect = () => httpClient.delete(`${PAYSTACK_ACCOUNT_API}/disconnect`)
